import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './components/loader/loader.component';
import { LoaderService } from './services/loader.service';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ImageModule } from 'primeng/image';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { TableModule } from 'primeng/table';
import { TreeModule } from 'primeng/tree';
import { TreeTableModule } from 'primeng/treetable';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { RouterModule } from '@angular/router';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CascadeSelectModule } from 'primeng/cascadeselect';
import { PaginatorModule } from 'primeng/paginator';
import { FileUploadModule } from 'primeng/fileupload';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { TabViewModule } from 'primeng/tabview';
import { DialogModule } from 'primeng/dialog';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { LayoutComponent } from './components/layout/layout.component';
import { LayoutService } from './services/layout.service';
import { ChartModule } from 'primeng/chart';
import { DialogService } from 'primeng/dynamicdialog';
import { HttpClientModule } from '@angular/common/http';
import { APIService } from '@core/services/api.service';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { OutSideClickDirective } from './directive/out-side-click.directive';
import { SidebarModule } from 'primeng/sidebar';
import { BookingStatusClassPipe, BookingStatusClassWithoutBorderPipe, CustomDatePipe, CustomDatePipeFinancial, LuxonFormatPipe, PaymentModeValuePipe, PaymentStatusClassPipe, RemoveDecimalPipe, customDate1, customDate2, invoicePaymentStatusPipe } from './custom-date-pipe';
import { MessageTimePipe, NumberFormatPipe } from './pipes/number-format.pipe'
import { SuccessFailedModalComponent } from './components/success-failed-modal/success-failed-modal.component'
import { DeleteModalComponent } from './components/delete-modal/delete-modal.component'
import { ResetPasswordModalComponent } from './components/reset-password-modal/reset-password-modal.component';
import { BookingInvoiceComponent } from './components/booking-invoice/booking-invoice.component';
import { ViewBookingComponent } from './components/view-booking/view-booking.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { MenuModule } from 'primeng/menu';
import { SuceesChangepasswordComponent } from './components/sucees-changepassword/sucees-changepassword.component';
import { ToastService } from './services/toast.service';
import { DigitFormatPipe } from './pipes/digits-format.pipe';
import { AccordionModule } from 'primeng/accordion';
import { ResetPasswordConfirmationComponent } from './components/reset-password-confirmation/reset-password-confirmation.component';
import { DeleteConfirmationModalComponent } from './components/delete-confirmation-modal/delete-confirmation-modal.component';
import { VehicleTypeModalComponent } from './components/vehicle-type-modal/vehicle-type-modal.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { JoinOurCommunityMapComponent } from './components/join-our-community/join-our-community-map.component';
import { JoinOurCommunityService } from '@core/services/join-our-community.service';
import { MenuService } from '@core/services/menu.service';
import { UserMessagesComponent } from './components/user-messages/user-messages.component';
import { BookingMessagesService } from '@core/services/booking-messages.service';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input-gg';
import { InviteDriverModalComponent } from './components/invite-driver/invite-driver-modal/invite-driver-modal.component';
import { OneTimeInvoiceComponent } from './components/one-time-invoice/one-time-invoice/one-time-invoice.component';
import { InvoiceListComponent } from './components/invoice-list/invoice-list.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DriverInvoiceListComponent } from './components/driver-invoice-list/driver-invoice-list.component';
import { FilterPipe } from './pipes/filter.pipe';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { TooltipPositionDirective } from './directive/tooltip.directive';
import { JsonDataService } from './services/json-data.service';
import { AppleAppSiteAssociationComponent } from './components/apple-app-site-association/apple-app-site-association.component';
import { AppRedirectService } from './services/api-redirect.service';
import { GalleriaModule } from 'primeng/galleria';
import { HeaderV1Component } from './components/header-v1/header-v1.component';
import { CookiesComponent } from './components/cookies/cookies.component';
import { GroupBookingInvoiceComponent } from './components/group-user-booking/group-booking-invoice/group-booking-invoice.component';
import { GroupViewBookingComponent } from './components/group-user-booking/group-view-booking/group-view-booking.component';
import { GroupBookingDetailsComponent } from './components/group-user-booking/group-booking-details/group-booking-details.component';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { AccessCodeModalComponent } from './components/access-code-modal/access-code-modal.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { CreateParkingComponent } from './components/parking-lot/create-parking/create-parking.component';
import { EditParkingSlotComponent } from './components/parking-lot/edit-parking-slot/edit-parking-slot.component';
import { EditParkingComponent } from './components/parking-lot/edit-parking/edit-parking.component';
import { MapsComponent } from './components/parking-lot/maps/maps.component';
import { ParkingListComponent } from './components/parking-lot/parking-list/parking-list.component';
import { ParkingSlotsComponent } from './components/parking-lot/parking-slots/parking-slots.component';
import { SuccessModalComponent } from './components/parking-lot/success-modal/success-modal.component';
import { ViewParkingComponent } from './components/parking-lot/view-parking/view-parking.component';
import { EditorModule } from 'primeng/editor';
import { MapAutoCompleteDirective } from './directive/map-auto-complete.directive';
import { FooterComponent } from './components/footer/footer.component';
import { FooterFormComponent } from './components/footer/footer-form/footer-form.component';
import { JoinUsComponent } from './components/footer/join-us/join-us.component';
import { PromoCodeManagementComponent } from '@shared/components/promo-code-management/promo-code-management.component';
import { GroupCancelBookingModalComponent } from '@shared/components/group-cancel-booking-modal/group-cancel-booking-modal.component';
import { CustomRatesPopupComponent } from './components/parking-lot/custom-rates-popup/custom-rates-popup.component';
import { UserCrmComponent } from './components/user-crm/user-crm.component';
import { GroupOpratorBasicInformationComponent } from './components/user-crm/group-oprator-basic-information/group-oprator-basic-information.component';
import { PaymentMethodComponent } from '../shared/components/payment-method/payment-method.component';
import { NotesComponent } from './components/notes/notes.component';
import { EquipmentInfoListComponent } from './components/equipment-info-list/equipment-info-list.component';
import { UserCrmBookingComponent } from './components/user-crm/user-crm-booking/user-crm-booking.component';
import { PaymentsDetailComponent } from './components/user-crm/payments-detail/payments-detail.component';
import { DriverBesicInformationComponent } from './components/user-crm/driver-basic-information/driver-basic-information.component';
import { CommonConfirmationModalComponent } from './components/common-confirmation-modal/common-confirmation-modal.component';
import { FinancialTabsComponent } from './components/financials/financial-tabs/financial-tabs.component';
import { CustomInvoiceComponent } from './components/custom-invoice/custom-invoice.component';
import { FinancialComponent } from './components/financials/financial/financial.component';
import { TransactionComponent } from './components/financials/transaction/transaction.component';
import { InvoiceBookingComponent } from './components/invoice-booking/invoice-booking.component';
import { CancelModalComponent } from './components/cancel-modal/cancel-modal.component';
import { RoleBasedUserListComponent } from './components/role-based-user-creation/role-based-user-list/role-based-user-list.component';
import { RoleBasedUserCreationComponent } from './components/role-based-user-creation/role-based-user-creation.component';
import { UserCrmCustomInvoiceComponent } from './components/user-crm/user-crm-custom-invoice/user-crm-custom-invoice.component';
import { CommonDashboardComponent } from './components/dashboard/common-dashboard/common-dashboard.component';
import { OccupancyChartComponent } from './components/dashboard/occupancy-chart/occupancy-chart.component';
import { RevenueChartComponent } from './components/dashboard/revenue-chart/revenue-chart.component';
import { RevenueDisplayComponent } from './components/dashboard/revenue-display/revenue-display.component';
import { MetricDisplayComponent } from './components/dashboard/metric-display/metric-display.component';
import { RevenueDashboardComponent } from './components/revenue-dashboard/revenue-dashboard.component';
import { RevenueCollectionDashboardComponent } from './components/revenue-collection-dashboard/revenue-collection-dashboard.component';
import { CalendarOpenerDirective } from './directive/calendar-opener.directive';
import { ProgressBarModule } from 'primeng/progressbar';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { PayRepayModalComponent } from './components/pay-repay-modal/pay-repay-modal.component';
import { ModifyBookingsPopupComponent } from './components/modify-bookings-popup/modify-bookings-popup.component';
import { ModifyPaymentModalComponent } from './components/modify-payment-popup-modal/modify-payment-popup-modal.component';
import { AddPaymentMethodComponent } from './components/add-payment-method/add-payment-method.component';
import { UserCrmFilterModalComponent } from './components/user-crm/user-crm-filter-modal/user-crm-filter-modal.component';
import { CustomCreditsComponent } from './components/custom-credits/custom-credits.component';
import { SharedInvoicePopupComponent } from './components/shared-invoice-popup/shared-invoice-popup.component';
import { ChipsModule } from 'primeng/chips';
import { CustomCreditListComponent } from './components/custom-credit-list/custom-credit-list.component';
import {  UserCreateModalComponent } from './components/driver/user-create-modal/user-create-modal.component';
import { VehicleInformationComponent } from './vehicle-information/vehicle-information.component';
import { EnterKeyListenerDirective } from './directive/enter-key.directive';
import { AddParkerAndEquipmentDrawerComponent } from './components/add-parker-and-equipment-drawer/add-parker-and-equipment-drawer.component';
import { AddParkerModalComponent } from './components/user-crm/add-parker-modal/add-parker-modal.component';
import { ParkerService } from './components/user-crm/services/parker.service';
import { ParkerListComponent } from './components/user-crm/parker-list/parker-list.component';
import { PredictiveMobileSearchComponentComponent } from './components/predictive-mobile-search-component/predictive-mobile-search-component.component';
import { RemovePakerConfirmModalComponent } from './components/user-crm/remove-paker-confirm-modal/remove-paker-confirm-modal.component';
import { CancelOptionModalComponent } from './components/cancel-option-modal/cancel-option-modal.component';
import { CancelRefundModalComponent } from './components/cancel-refund-modal/cancel-refund-modal.component';
import { SpotUpdateConfimationModalComponent } from './components/spot-update-confimation-modal/spot-update-confimation-modal.component';
import { SpotCountUpdatePaymentModalComponent } from './components/spot-count-update-payment-modal/spot-count-update-payment-modal.component';
import { SpotCountUpdateModalComponent } from './components/spot-count-update-modal/spot-count-update-modal.component';
import { StripeSlotUpdatePopupComponent } from './components/footer/stripe-slot-update-popup/stripe-slot-update-popup.component';
import { SpotCountUpdateSuccessModalComponent } from './components/spot-count-update-success-modal/spot-count-update-success-modal.component';
import { GroupModifyBookingsPopupComponent } from './components/group-modify-bookings-popup/group-modify-bookings-popup.component';
import { UpdatePaymentDateModalComponent } from './components/update-payment-date-modal/update-payment-date-modal.component';
import { ScheduleDateTimeOptionComponent } from './components/schedule-date-time-option/schedule-date-time-option.component';
import { ReattemptBookingModalComponent } from './components/reattempt-booking-modal/reattempt-booking-modal.component';
import { hideShowDropdownDirective } from './directive/dropdown-open-close.directive';
import { UserConvertToGroupOperatorModalComponent } from './components/user-convert-to-group-operator-modal/user-convert-to-group-operator-modal.component';
import { SurveyListComponent } from './components/survey-list/survey-list.component';

@NgModule({
  declarations: [
    MapAutoCompleteDirective,
    LoaderComponent,
    HeaderComponent,
    SidebarComponent,
    LayoutComponent,
    OutSideClickDirective,
    CustomDatePipe,
    CustomDatePipeFinancial,
    NumberFormatPipe,
    FilterPipe,
    DigitFormatPipe,
    customDate2,
    LuxonFormatPipe,
    SuccessFailedModalComponent,
    DeleteModalComponent,
    ResetPasswordModalComponent,
    BookingInvoiceComponent,
    ViewBookingComponent,
    ResetPasswordComponent,
    SuceesChangepasswordComponent,
    customDate1,
    RemoveDecimalPipe,
    ResetPasswordConfirmationComponent,
    DeleteConfirmationModalComponent,
    CancelModalComponent,
    CancelOptionModalComponent,
    CancelRefundModalComponent,
    VehicleTypeModalComponent,
    FinancialComponent,
    JoinOurCommunityMapComponent,
    UserMessagesComponent,
    MessageTimePipe,
    OneTimeInvoiceComponent,
    InvoiceListComponent,
    InviteDriverModalComponent,
    DriverInvoiceListComponent,
    TooltipPositionDirective,
    AppleAppSiteAssociationComponent,
    HeaderV1Component,
    GroupBookingInvoiceComponent,
    GroupViewBookingComponent,
    CookiesComponent,
    GroupBookingDetailsComponent,
    AccessCodeModalComponent,
    TooltipComponent,
    CreateParkingComponent,
    EditParkingComponent,
    ParkingSlotsComponent,
    SuccessModalComponent,
    EditParkingSlotComponent,
    MapsComponent,
    ViewParkingComponent,
    ParkingListComponent,
    FooterComponent,
    FooterFormComponent,
    JoinUsComponent,
    PromoCodeManagementComponent,
    GroupCancelBookingModalComponent,
    CustomRatesPopupComponent,
    UserCrmComponent,
    DriverBesicInformationComponent,
    GroupOpratorBasicInformationComponent,
    PaymentMethodComponent,
    NotesComponent,
    EquipmentInfoListComponent,
    UserCrmBookingComponent,
    PaymentsDetailComponent,
    CommonConfirmationModalComponent,
    CustomInvoiceComponent,
    FinancialTabsComponent,
    TransactionComponent,
    InvoiceBookingComponent,
    RoleBasedUserListComponent,
    RoleBasedUserCreationComponent,
    UserCrmCustomInvoiceComponent,
    CommonDashboardComponent,
    OccupancyChartComponent,
    RevenueChartComponent,
    RevenueDisplayComponent,
    MetricDisplayComponent,
    RevenueDashboardComponent,
    RevenueCollectionDashboardComponent,
    PaymentModeValuePipe,
    PaymentStatusClassPipe,
    BookingStatusClassPipe,
    invoicePaymentStatusPipe,
    BookingStatusClassWithoutBorderPipe,
    CalendarOpenerDirective,
    PayRepayModalComponent,
    ModifyBookingsPopupComponent,
    ModifyPaymentModalComponent,
    AddPaymentMethodComponent,
    SharedInvoicePopupComponent,
    UserCrmFilterModalComponent,
    CustomCreditsComponent,
    CustomCreditListComponent,
    UserCreateModalComponent,
    VehicleInformationComponent,
    EnterKeyListenerDirective,
    AddParkerAndEquipmentDrawerComponent,
    AddParkerModalComponent,
    ParkerListComponent,
    PredictiveMobileSearchComponentComponent,
    RemovePakerConfirmModalComponent,
    SpotUpdateConfimationModalComponent,
    SpotCountUpdatePaymentModalComponent,
    SpotCountUpdateModalComponent,
    StripeSlotUpdatePopupComponent,
    SpotCountUpdateSuccessModalComponent,
    GroupModifyBookingsPopupComponent,
    UpdatePaymentDateModalComponent,
    ScheduleDateTimeOptionComponent,
    ReattemptBookingModalComponent,
    hideShowDropdownDirective,
    UserConvertToGroupOperatorModalComponent,
    SurveyListComponent
  ],
  imports: [
    AccordionModule,
    TabViewModule,
    InputTextModule,
    ButtonModule,
    ImageModule,
    NgxIntlTelInputModule,
    PasswordModule,
    CheckboxModule,
    TableModule,
    TreeModule,
    TreeTableModule,
    ReactiveFormsModule,
    ToggleButtonModule,
    MenuModule,
    ToastModule,
    RouterModule,
    RadioButtonModule,
    CascadeSelectModule,
    PaginatorModule,
    AutoCompleteModule,
    FileUploadModule,
    ProgressSpinnerModule,
    ImageModule,
    CalendarModule,
    InlineSVGModule,
    FormsModule,
    InputNumberModule,
    TabViewModule,
    ChartModule,
    EditorModule,
    SidebarModule,
    DialogModule,
    HttpClientModule,
    NgOtpInputModule,
    NgxIntlTelInputModule,
    CommonModule,
    DropdownModule,
    MultiSelectModule,
    GalleriaModule,
    ConfirmPopupModule,
    ProgressBarModule,
    NgCircleProgressModule,
    ChipsModule,
  ],
  providers: [
    LoaderService,
    MessageService,
    LayoutService,
    DialogService,
    APIService,
    ToastService,
    JoinOurCommunityService,
    MenuService,
    BookingMessagesService,
    JoinOurCommunityService,
    JsonDataService,
    AppRedirectService,
    ParkerService
  ],
  exports: [
    LoaderComponent,
    HeaderComponent,
    SidebarComponent,
    LayoutComponent,
    CommonModule,
    InputTextModule,
    NgOtpInputModule,
    NgxIntlTelInputModule,
    ButtonModule,
    MultiSelectModule,
    InlineSVGModule,
    ImageModule,
    ToggleButtonModule,
    MenuModule,
    PasswordModule,
    CheckboxModule,
    TableModule,
    ChartModule,
    EditorModule,
    ReactiveFormsModule,
    ToastModule,
    RouterModule,
    ProgressSpinnerModule,
    MenuModule,
    SidebarModule,
    RadioButtonModule,
    CascadeSelectModule,
    PaginatorModule,
    FileUploadModule,
    ImageModule,
    CalendarModule,
    FormsModule,
    InputNumberModule,
    TabViewModule,
    DialogModule,
    HttpClientModule,
    OutSideClickDirective,
    CustomDatePipe,
    CustomDatePipeFinancial,
    NumberFormatPipe,
    FilterPipe,
    customDate2,
    SuccessFailedModalComponent,
    DeleteModalComponent,
    ResetPasswordModalComponent,
    SharedInvoicePopupComponent,
    JoinOurCommunityMapComponent,
    DigitFormatPipe,
    LuxonFormatPipe,
    customDate1,
    RemoveDecimalPipe,
    VehicleTypeModalComponent,
    UserMessagesComponent,
    FormsModule,
    DropdownModule,
    MultiSelectModule,
    TooltipPositionDirective,
    AppleAppSiteAssociationComponent,
    AutoCompleteModule,
    GalleriaModule,
    HeaderV1Component,
    GroupBookingInvoiceComponent,
    GroupViewBookingComponent,
    CookiesComponent,
    GroupBookingDetailsComponent,
    AccessCodeModalComponent,
    TooltipComponent,
    CreateParkingComponent,
    EditParkingComponent,
    ParkingSlotsComponent,
    SuccessModalComponent,
    EditParkingSlotComponent,
    MapsComponent,
    ViewParkingComponent,
    ParkingListComponent,
    FooterComponent,
    FooterFormComponent,
    JoinUsComponent,
    PromoCodeManagementComponent,
    MapAutoCompleteDirective,
    PaymentMethodComponent,
    FinancialTabsComponent,
    CustomInvoiceComponent,
    TransactionComponent,
    CancelModalComponent,
    CancelOptionModalComponent,
    CancelRefundModalComponent,
    RoleBasedUserListComponent,
    RoleBasedUserCreationComponent,
    InvoiceBookingComponent,
    CommonDashboardComponent,
    OccupancyChartComponent,
    RevenueChartComponent,
    RevenueDisplayComponent,
    MetricDisplayComponent,
    PaymentModeValuePipe,
    PaymentStatusClassPipe,
    BookingStatusClassPipe,
    invoicePaymentStatusPipe,
    BookingStatusClassWithoutBorderPipe,
    CalendarOpenerDirective,
    ProgressBarModule,
    NgCircleProgressModule,
    ChipsModule,
    PayRepayModalComponent,
    ModifyPaymentModalComponent,
    AddPaymentMethodComponent,
    UserCreateModalComponent,
    VehicleInformationComponent,
    EnterKeyListenerDirective,
    AddParkerAndEquipmentDrawerComponent,
    AddParkerModalComponent,
    ParkerListComponent,
    PredictiveMobileSearchComponentComponent,
    SpotUpdateConfimationModalComponent,
    SpotCountUpdatePaymentModalComponent,
    SpotCountUpdateModalComponent,
    UpdatePaymentDateModalComponent,
    ScheduleDateTimeOptionComponent,
    hideShowDropdownDirective,
    SurveyListComponent,
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
